import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { CurrentContextService } from '../context/current-context.service';
import { currentAppScope } from '../scope/app-scope';
import { TokenStorageService } from './token-storage.service';

export const authGuard: CanActivateFn = () => {
  const tokenStorage = inject(TokenStorageService);
  const router = inject(Router);
  const contextService = inject(CurrentContextService);

  if (!tokenStorage.getAccessToken()) {
    return router.parseUrl('/login');
  }

  return contextService.loadContext().pipe(
    map(context => {
      const appScope = currentAppScope();
      if (appScope === 'organization') {
        return true;
      }

      if (context.isPlatformAdmin) {
        return true;
      }

      tokenStorage.clear();
      return router.parseUrl('/login');
    }),
    catchError(() => {
      tokenStorage.clear();
      return of(router.parseUrl('/login'));
    })
  );
};
